import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const KYCManagementPanel = () => {
  const [selectedFilter, setSelectedFilter] = useState('pending');
  const [selectedVerification, setSelectedVerification] = useState(null);

  const kycVerifications = [
  {
    id: 1,
    userId: "USR2025001",
    userName: "Rajesh Kumar Sharma",
    userType: "Sugar Buyer",
    submittedDate: "2025-11-28",
    documents: [
    { type: "Aadhaar Card", status: "verified", url: "https://img.rocket.new/generatedImages/rocket_gen_img_19f9f594c-1764740086474.png", alt: "Aadhaar card document showing identification details with photo and government seal" },
    { type: "PAN Card", status: "verified", url: "https://img.rocket.new/generatedImages/rocket_gen_img_15a0d30d9-1776248850426.png", alt: "PAN card document displaying permanent account number and holder details" },
    { type: "GST Certificate", status: "pending", url: "https://img.rocket.new/generatedImages/rocket_gen_img_182521032-1766320915814.png", alt: "GST registration certificate showing business registration number and tax details" }],

    status: "pending",
    priority: "high"
  },
  {
    id: 2,
    userId: "USR2025002",
    userName: "Priya Patel",
    userType: "Transporter",
    submittedDate: "2025-11-27",
    documents: [
    { type: "Driving License", status: "verified", url: "https://img.rocket.new/generatedImages/rocket_gen_img_1bb034991-1776256691643.png", alt: "Valid driving license document with photo and vehicle authorization details" },
    { type: "Vehicle RC", status: "verified", url: "https://img.rocket.new/generatedImages/rocket_gen_img_16f64c093-1772082722570.png", alt: "Vehicle registration certificate showing ownership and vehicle specifications" },
    { type: "Insurance Certificate", status: "verified", url: "https://img.rocket.new/generatedImages/rocket_gen_img_1d29c473a-1764933721673.png", alt: "Vehicle insurance certificate displaying coverage details and validity period" }],

    status: "verified",
    priority: "medium"
  },
  {
    id: 3,
    userId: "USR2025003",
    userName: "Amit Singh",
    userType: "Factory Manager",
    submittedDate: "2025-11-26",
    documents: [
    { type: "Factory License", status: "pending", url: "https://img.rocket.new/generatedImages/rocket_gen_img_1553d21d1-1776248850272.png", alt: "Factory operating license document with registration number and authorization stamp" },
    { type: "FSSAI Certificate", status: "pending", url: "https://img.rocket.new/generatedImages/rocket_gen_img_14ff644b3-1768029757104.png", alt: "FSSAI food safety certificate showing compliance and registration details" }],

    status: "pending",
    priority: "high"
  },
  {
    id: 4,
    userId: "USR2025004",
    userName: "Sunita Deshmukh",
    userType: "Sugar Buyer",
    submittedDate: "2025-11-25",
    documents: [
    { type: "Aadhaar Card", status: "rejected", url: "https://img.rocket.new/generatedImages/rocket_gen_img_14beb12b0-1776709193919.png", alt: "Aadhaar card document with unclear photo requiring resubmission" },
    { type: "PAN Card", status: "verified", url: "https://img.rocket.new/generatedImages/rocket_gen_img_1e33add0a-1776256692046.png", alt: "PAN card document showing valid permanent account number details" }],

    status: "rejected",
    priority: "low",
    rejectionReason: "Aadhaar card image is unclear. Please resubmit a clear copy."
  }];


  const filterOptions = [
  { value: 'all', label: 'All Verifications' },
  { value: 'pending', label: 'Pending Review' },
  { value: 'verified', label: 'Verified' },
  { value: 'rejected', label: 'Rejected' }];


  const filteredVerifications = kycVerifications?.filter((v) =>
  selectedFilter === 'all' ? true : v?.status === selectedFilter
  );

  const handleApprove = (verificationId) => {
    console.log('Approved verification:', verificationId);
  };

  const handleReject = (verificationId) => {
    console.log('Rejected verification:', verificationId);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'verified':return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
      case 'pending':return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
      case 'rejected':return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
      default:return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':return 'text-red-600 dark:text-red-400';
      case 'medium':return 'text-yellow-600 dark:text-yellow-400';
      case 'low':return 'text-green-600 dark:text-green-400';
      default:return 'text-gray-600 dark:text-gray-400';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-3 sm:p-4 md:p-5 lg:p-6 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 md:gap-4 lg:gap-5 mb-4 sm:mb-5 md:mb-6">
        <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
          <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-11 md:h-11 lg:w-12 lg:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="UserCheck" size={16} className="sm:hidden text-primary" />
            <Icon name="UserCheck" size={18} className="hidden sm:block md:hidden text-primary" />
            <Icon name="UserCheck" size={20} className="hidden md:block lg:hidden text-primary" />
            <Icon name="UserCheck" size={22} className="hidden lg:block text-primary" />
          </div>
          <div className="min-w-0 flex-1">
            <h2 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
              KYC Management
            </h2>
            <p className="text-xs sm:text-sm md:text-base text-muted-foreground">
              Review and approve user verifications
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 md:gap-4">
          <Select
            options={filterOptions}
            value={selectedFilter}
            onChange={setSelectedFilter}
            placeholder="Filter by status"
            className="w-full sm:w-44 md:w-48 lg:w-52" />
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            className="w-full sm:w-auto text-xs sm:text-sm md:text-base whitespace-nowrap">
            
            Export Report
          </Button>
        </div>
      </div>

      <div className="space-y-3 sm:space-y-4 md:space-y-5">
        {filteredVerifications?.map((verification) =>
        <div
          key={verification?.id}
          className="border border-border rounded-lg p-3 sm:p-4 md:p-5 lg:p-6 hover:border-primary/50 hover:shadow-md transition-all duration-200">
          
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3 sm:gap-4 mb-3 sm:mb-4 md:mb-5">
              <div className="flex items-start gap-2 sm:gap-3 md:gap-4 min-w-0 flex-1">
                <div className="w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="User" size={18} className="sm:hidden text-primary" />
                  <Icon name="User" size={20} className="hidden sm:block md:hidden text-primary" />
                  <Icon name="User" size={22} className="hidden md:block lg:hidden text-primary" />
                  <Icon name="User" size={24} className="hidden lg:block text-primary" />
                </div>
                
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2 mb-1 sm:mb-1.5">
                    <h3 className="font-semibold text-foreground text-sm sm:text-base md:text-lg">
                      {verification?.userName}
                    </h3>
                    <span className={`px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap ${getStatusColor(verification?.status)}`}>
                      {verification?.status?.charAt(0)?.toUpperCase() + verification?.status?.slice(1)}
                    </span>
                  </div>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-3 sm:gap-x-4 gap-y-1 sm:gap-y-1.5 text-xs sm:text-sm md:text-base text-muted-foreground">
                    <span className="flex items-center gap-1 sm:gap-1.5 truncate">
                      <Icon name="Briefcase" size={12} className="sm:hidden flex-shrink-0" />
                      <Icon name="Briefcase" size={14} className="hidden sm:block flex-shrink-0" />
                      <span className="truncate">{verification?.userType}</span>
                    </span>
                    <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap">
                      <Icon name="Hash" size={12} className="sm:hidden flex-shrink-0" />
                      <Icon name="Hash" size={14} className="hidden sm:block flex-shrink-0" />
                      {verification?.userId}
                    </span>
                    <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap">
                      <Icon name="Calendar" size={12} className="sm:hidden flex-shrink-0" />
                      <Icon name="Calendar" size={14} className="hidden sm:block flex-shrink-0" />
                      {new Date(verification.submittedDate)?.toLocaleDateString('en-IN')}
                    </span>
                    <span className={`flex items-center gap-1 sm:gap-1.5 font-medium whitespace-nowrap ${getPriorityColor(verification?.priority)}`}>
                      <Icon name="AlertCircle" size={12} className="sm:hidden flex-shrink-0" />
                      <Icon name="AlertCircle" size={14} className="hidden sm:block flex-shrink-0" />
                      {verification?.priority?.toUpperCase()} Priority
                    </span>
                  </div>
                </div>
              </div>
              
              {verification?.status === 'pending' &&
            <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto lg:w-auto">
                  <Button
                variant="success"
                size="sm"
                iconName="Check"
                onClick={() => handleApprove(verification?.id)}
                className="flex-1 sm:flex-none lg:flex-none text-xs sm:text-sm md:text-base">
                
                    Approve
                  </Button>
                  <Button
                variant="destructive"
                size="sm"
                iconName="X"
                onClick={() => handleReject(verification?.id)}
                className="flex-1 sm:flex-none lg:flex-none text-xs sm:text-sm md:text-base">
                
                    Reject
                  </Button>
                </div>
            }
            </div>

            {verification?.status === 'rejected' && verification?.rejectionReason &&
          <div className="mb-3 sm:mb-4 md:mb-5 p-3 sm:p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md">
                <div className="flex items-start gap-2 sm:gap-3">
                  <Icon name="AlertTriangle" size={16} className="sm:hidden text-red-600 dark:text-red-400 mt-0.5 flex-shrink-0" />
                  <Icon name="AlertTriangle" size={18} className="hidden sm:block text-red-600 dark:text-red-400 mt-0.5 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-xs sm:text-sm md:text-base font-medium text-red-800 dark:text-red-400">
                      Rejection Reason
                    </p>
                    <p className="text-xs sm:text-sm md:text-base text-red-700 dark:text-red-300 break-words">
                      {verification?.rejectionReason}
                    </p>
                  </div>
                </div>
              </div>
          }

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-3 sm:gap-4 md:gap-5">
              {verification?.documents?.map((doc, index) =>
            <div key={index} className="border border-border rounded-lg p-3 sm:p-4 hover:border-primary/30 transition-colors">
                  <div className="flex items-center justify-between mb-2 sm:mb-3">
                    <span className="text-xs sm:text-sm md:text-base font-medium text-foreground truncate">
                      {doc?.type}
                    </span>
                    <span className={`px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(doc?.status)}`}>
                      {doc?.status}
                    </span>
                  </div>
                  
                  <div className="aspect-video bg-muted rounded-md overflow-hidden mb-2 sm:mb-3">
                    <Image
                  src={doc?.url}
                  alt={doc?.alt}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-200" />
                
                  </div>
                  
                  <Button
                variant="outline"
                size="sm"
                fullWidth
                iconName="Eye"
                onClick={() => setSelectedVerification({ ...verification, document: doc })}
                className="text-xs sm:text-sm">
                
                    View Document
                  </Button>
                </div>
            )}
            </div>
          </div>
        )}
      </div>

      {filteredVerifications?.length === 0 &&
      <div className="text-center py-10 sm:py-12 md:py-16">
          <Icon name="FileSearch" size={40} className="sm:hidden text-muted-foreground mx-auto mb-3" />
          <Icon name="FileSearch" size={48} className="hidden sm:block md:hidden text-muted-foreground mx-auto mb-4" />
          <Icon name="FileSearch" size={56} className="hidden md:block text-muted-foreground mx-auto mb-4" />
          <p className="text-sm sm:text-base md:text-lg text-muted-foreground">
            No verifications found for the selected filter
          </p>
        </div>
      }
    </div>);

};

export default KYCManagementPanel;